import { render, staticRenderFns } from "./KothonCallHistory.vue?vue&type=template&id=16ba4600&scoped=true"
import script from "./KothonCallHistory.vue?vue&type=script&lang=js"
export * from "./KothonCallHistory.vue?vue&type=script&lang=js"
import style0 from "./KothonCallHistory.vue?vue&type=style&index=0&id=16ba4600&prod&lang=scss"
import style1 from "./KothonCallHistory.vue?vue&type=style&index=1&id=16ba4600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba4600",
  null
  
)

export default component.exports